<template>
    <div>
        <rkm-area
            background-color="secondary"
            title="Desfecho"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        :validations="validations.desfecho"
                        class="mt-1 mb-2"
                        name="Desfecho"
                        v-model="data.model.desfecho.finalizado"
                        @change="handleDesfechoChange"
                    >
                        <rkm-form-radio
                            v-if="data.additionals.podeFinalizarAtendimento === true"
                            :value="true"
                        >
                            Liberar paciente
                        </rkm-form-radio>
                        <rkm-form-radio :value="false">Manter na fila</rkm-form-radio>
                        <rkm-form-radio :value="'encaminhar'">Encaminhar paciente</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <template v-if="data.model.desfecho.finalizado === false || data.model.desfecho.finalizado === 'encaminhar'">
                <rkm-row v-if="data.model.desfecho.finalizado === 'encaminhar'">
                    <rkm-col>
                        <rkm-form-select
                            :options="data.form.desfecho.centrosCustoEncaminhamento"
                            :validations="validations.centroCustoEncaminhamento"
                            label="Encaminhamento"
                            show-default-option
                            text-field="setorNome"
                            v-model="data.model.desfecho.centroCustoEncaminhamentoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col
                        v-if="isSetorEncaminhamentoEnfermagem"
                        cols="auto"
                    >
                        <rkm-form-checkbox
                            :label="false"
                            @change="handlePosCosultaChange"
                            v-model="data.model.desfecho.posConsulta"
                        >
                            Pós-consulta
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="data.additionals.isDemandaEspontanea === true">
                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.usuarios"
                            @change="handleUsuarioChange"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.ocupacoes"
                            @change="handleOcupacaoChange"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="data.model.desfecho.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="demandaEspontaneaObservaVagaAtendimento"
                            :options="data.form.desfecho.especialidades"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col v-if="demandaEspontaneaObservaVagaAtendimento">
                        <rkm-form-select
                            :options="data.form.desfecho.jornadas"
                            disabled
                            label="Jornada"
                            show-default-option
                            text-field="descricao"
                            v-model="data.model.desfecho.jornadaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="data.form.desfecho.servicos.length > 0">
                    <rkm-col>
                        <rkm-form-checkbox-group
                            :options="data.form.desfecho.servicos"
                            label="Serviços"
                            text-field="nome"
                            v-model="data.model.desfecho.servicos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :options="data.form.desfecho.opcoesEntrada"
                            :validations="validations.opcaoEntrada"
                            disabled
                            label="Opção de entrada"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.opcaoEntradaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :options="data.form.desfecho.prioridades"
                            :validations="validations.prioridade"
                            label="Prioridade"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.desfecho.prioridadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import servicoTipo from '@/enums/ambulatorio/servicoTipo'

export default {
    computed: {
        validations() {
            return {
                desfecho: {required: true},
                prioridade: {
                    required:
                        !!this.data.model.desfecho.opcaoEntradaId &&
                        this.data.form.desfecho.opcoesEntrada.find(opcaoEntrada => opcaoEntrada.id === this.data.model.desfecho.opcaoEntradaId).prioridadeObrigatoria
                },
                centroCustoEncaminhamento: {required: true},
            }
        },
        isSetorEncaminhamentoEnfermagem() {
            if (!this.data.model.desfecho.centroCustoEncaminhamentoId) {
                return false
            }

            return this.data.form.desfecho.centrosCustoEncaminhamento
                .find(cc => cc.id === this.data.model.desfecho.centroCustoEncaminhamentoId)
                .setorTipoId === this.enums.setorTipo.ENFERMAGEM
        },
        demandaEspontaneaObservaVagaAtendimento() {
            return this.data.form.desfecho.especialidades.find(especialidade => especialidade.id === this.data.model.desfecho.especialidadeId)?.demandaEspontaneaObservaVagaAtendimento === true
        },
    },
    created() {
        this.repositories = {
            atendimentoEnfermagem: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
        }
    },
    data: () => ({
        enums: {
            setorTipo,
            servicoTipo,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUsuarioChange(value) {
            this.data.form.desfecho.ocupacoes = []
            this.data.form.desfecho.especialidades = []
            this.data.model.desfecho.ocupacaoId = null
            this.data.model.desfecho.especialidadeId = null

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.data.form.desfecho.especialidades = []
            this.data.model.desfecho.especialidadeId = null

            if (value === null) return

            this.getEspecialidades(this.data.model.desfecho.usuarioId, value)
        },
        handleDesfechoChange(value) {
            if (value !== 'encaminhar') {
                this.data.model.desfecho.centroCustoEncaminhamentoId = null
                this.data.model.desfecho.servicos = []

                if (this.demandaEspontaneaObservaVagaAtendimento === false) {
                    this.data.model.desfecho.usuarioId = null
                    this.data.model.desfecho.ocupacaoId = null
                    this.data.model.desfecho.especialidadeId = null
                }
            }
        },
        getOcupacoes(usuarioId) {
            const request = {
                funcionalidade: 'pre-atendimento',
                listar: 'ocupacoes',
                filaId: this.filaId,
                usuarioId,
            }

            this.setLoading()

            this.repositories.atendimentoEnfermagem.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.ocupacoes = Object.assign(response.data.ocupacoes)

                    if (this.data.form.desfecho.ocupacoes.length === 1) {
                        const ocupacaoId = this.data.form.desfecho.ocupacoes[0].id

                        this.data.model.desfecho.ocupacaoId = ocupacaoId

                        this.getEspecialidades(this.data.model.desfecho.usuarioId, ocupacaoId)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEspecialidades(usuarioId, ocupacaoId) {
            const request = {
                funcionalidade: 'pre-atendimento',
                listar: 'especialidades',
                filaId: this.filaId,
                usuarioId,
                ocupacaoId,
            }

            this.setLoading()

            this.repositories.atendimentoEnfermagem.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.desfecho.especialidades = Object.assign(response.data.especialidades)

                    if (this.data.form.desfecho.especialidades.length === 1) {
                        this.data.model.desfecho.especialidadeId = this.data.form.desfecho.especialidades[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePosCosultaChange(checked) {
            if (checked) {
                this.checkServicosPosConsulta()
            }
            else {
                this.uncheckServicosPosConsulta()
            }
        },
        checkServicosPosConsulta() {
            this.data.form.desfecho.servicos
                .filter(s => s.tipoId === this.enums.servicoTipo.POS_CONSULTA && !this.data.model.desfecho.servicos.includes(s.id))
                .forEach(s => this.data.model.desfecho.servicos.push(s.id))
        },
        uncheckServicosPosConsulta() {
            this.data.form.desfecho.servicos
                .filter(s => s.tipoId === this.enums.servicoTipo.POS_CONSULTA && this.data.model.desfecho.servicos.includes(s.id))
                .forEach(s => this.data.model.desfecho.servicos.splice(this.data.model.desfecho.servicos.indexOf(s.id), 1))
        }
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        filaId: {type: Number, required: true},
    },
    watch: {
        isSetorEncaminhamentoEnfermagem(isSetorEncaminhamentoEnfermagem) {
            if (isSetorEncaminhamentoEnfermagem) {
                if (this.data.model.desfecho.posConsulta) {
                    this.checkServicosPosConsulta()
                }
            }
            else {
                this.uncheckServicosPosConsulta()
            }
        }
    }
}
</script>